/**
 * Toast — notifications non bloquantes (remplace alert()).
 */
import { h } from "./dom.js";

export type ToastKind = "success" | "error" | "info" | "warning";

const DURATION_MS = 4500;

let stack: HTMLElement | null = null;

function ensureStack(): HTMLElement {
	if (!stack || !stack.isConnected) {
		stack = h("div", { class: "toast-stack", role: "status", "aria-live": "polite" });
		document.body.appendChild(stack);
	}
	return stack;
}

export function toast(message: string, kind: ToastKind = "info"): void {
	const icons: Record<ToastKind, string> = {
		success: "✓",
		error: "✕",
		info: "ℹ",
		warning: "⚠",
	};
	const el = h(
		"div",
		{ class: `toast toast-${kind}` },
		h("span", null, icons[kind]),
		h("span", null, message)
	);
	ensureStack().appendChild(el);
	window.setTimeout(() => dismiss(el), DURATION_MS);
}

function dismiss(el: HTMLElement): void {
	if (!el.isConnected) return;
	el.classList.add("leaving");
	window.setTimeout(() => el.remove(), 200);
}
